import { getCurrentApiHost, API_NAMESPACE, API_VERSION } from 'config/environment';
export const useCognitoAuth = ({ data })=>{
    var _data_okta_idps_find, _data_okta_idps;
    const idpId = data === null || data === void 0 ? void 0 : (_data_okta_idps = data.okta.idps) === null || _data_okta_idps === void 0 ? void 0 : (_data_okta_idps_find = _data_okta_idps.find((idp)=>idp.enabled)) === null || _data_okta_idps_find === void 0 ? void 0 : _data_okta_idps_find.idpId;
    const generateRandomString = (length)=>{
        const result = [];
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        const charactersLength = characters.length;
        for(let i = 0; i < length; i += 1){
            result.push(characters.charAt(Math.floor(Math.random() * charactersLength)));
        }
        return result.join('');
    };
    function base64UrlEncode(buffer) {
        return btoa(String.fromCharCode(...new Uint8Array(buffer))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    }
    // Function to get the SHA-256 digest of a given input
    async function sha256Digest(input) {
        const encoder = new TextEncoder();
        const _data = encoder.encode(input);
        return crypto.subtle.digest('SHA-256', _data);
    }
    const samlFlowHandler = async ()=>{
        const clientId = data === null || data === void 0 ? void 0 : data.okta.clientId;
        const issuerDomain = data === null || data === void 0 ? void 0 : data.okta.issuerDomain;
        const responseType = 'code';
        const scope = 'openid profile email';
        const state = generateRandomString(64);
        const nounce = generateRandomString(64);
        const _codeVerifier = generateRandomString(43);
        // Mirror to localStorage too: Safari ITP / enterprise / incognito can clear sessionStorage
        // during the cross-origin SAML/SSO redirect, which would lose the PKCE verifier and produce
        // code_verifier=undefined on the /implicit/callback exchange.
        sessionStorage.setItem('codeVerifier', _codeVerifier);
        try {
            localStorage.setItem('codeVerifier', _codeVerifier);
        } catch (unused) {
        // localStorage may be blocked (private mode / enterprise policy / quota); sessionStorage
        // still holds the verifier for the normal path — don't let this best-effort mirror throw.
        }
        const codeChallenge = base64UrlEncode(await sha256Digest(_codeVerifier));
        const codeChallengeMethod = 'S256';
        const redirectUri = `${window.location.origin}/implicit/callback`;
        const params = new URLSearchParams({
            client_id: clientId || '',
            redirect_uri: redirectUri,
            issuer: issuerDomain || '',
            idp: idpId || '',
            response_type: responseType,
            scope,
            state,
            nounce,
            code_challenge: codeChallenge,
            code_challenge_method: codeChallengeMethod
        });
        window.location.href = `${issuerDomain}/oauth2/authorize?${params.toString()}`;
    };
    const googleSSOHandler = ()=>{
        const BASEURL = `${getCurrentApiHost()}/${API_NAMESPACE}/${API_VERSION}`;
        window.location.href = `${BASEURL}/google/oauth2/initiate`;
    };
    return {
        samlFlowHandler,
        googleSSOHandler
    };
};
